import React, { useReducer, useContext, useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";

// MUI imports
import { Button, Grid, Typography } from "@mui/material";

// Project imports
import SectionFive from "./SectionFive";

import {
  saveFormDataPartTwo,
  nextFormStep,
  previousFormStep,
} from "../../../Actions";

import {
  TrainingCentreRegContext,
  tableCustomization,
} from "../helperFunctions";
import AcquiredCertificationsForm from "./AcquiredCertificationsForm";

import TextFieldTR from "../FormComponents/TextFieldTR";
import SelectTR from "../FormComponents/SelectTR";
import ButtonTR from "../FormComponents/ButtonTR";

const initialState = {
  trainers: [],

  // form controlled values
  isOwner: false,
  fileHolder: "",

  file: "", // base64 going to the API
  fileName: "",
  fileExtension: "",

  // certification states
  listOfCerts: [],
  certificationName: "",
  issuedBy: "",
};

const INITIAL_STATE = {
  firstName: "",
  middleName: "",
  lastName: "",
  skillId: "",
  yearsOfExperience: "",
  generalComment: "",
  ownerPhoneNumber: "",
};

const formValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("This is a required field."),
  middleName: Yup.string(),
  lastName: Yup.string().required("This is a required field."),
  skillId: Yup.string().required("This is a required field"),
  yearsOfExperience: Yup.number()
    .integer()
    .required("This is a required field")
    .typeError("Please enter a valid number"),
  generalComment: Yup.string().required("This is a required field."),
  ownerPhoneNumber: Yup.number()
    .integer()
    .typeError("Please enter a valid phone number"),
});

const reducer = (state, action) => {
  /* dispatch body convention -->> { type: [string], body: [action specific object] } */

  switch (action.type) {
    case "toggledStaffStatus": {
      return {
        ...state,
        isOwner: !state.isOwner,
      };
    }
    case "deletedStaffData": {
      const oldStaffList = state.trainers;

      const newStaffList = oldStaffList.filter((el, index) => {
        if (index === action.body) return false;
        else return true;
      });

      return {
        ...state,
        trainers: newStaffList,
      };
    }
    case "deletedStagedCertificate": {
      const oldCertList = state.listOfCerts;

      const newCertList = oldCertList.filter((el, index) => {
        if (index === action.body) return false;
        else return true;
      });

      return {
        ...state,
        listOfCerts: newCertList,
      };
    }
    case "stagedCertificate": {
      const newArr = [...state.listOfCerts, action.body];

      return {
        ...state,
        listOfCerts: newArr,
      };
    }
    case "changedOwnerPhoneNumber": {
      return {
        ...state,
        ownerPhoneNumber: action.body,
      };
    }
    case "stageStaffInfo": {
      const newStaffList = state.trainers;
      newStaffList.push(action.body);

      return {
        ...state,
        trainers: newStaffList,
      };
    }
    case "syncLocalStore": {
      return {
        ...state,
        ...action.body,
      };
    }
    case "emptyCertList": {
      return {
        ...state,
        listOfCerts: [],
      };
    }
    default:
      break;
  }
};

const PartTwo = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [equipmentAdded, setEquipmentAdded] = useState(false);
  const [sendDataToGlobalStore, setSendDataToGlobalStore] = useState(false);

  const globalDispatch = useDispatch();
  const trainingCentreRegReducer = (globalState) =>
    globalState.trainingCentreRegReducer;

  const { trainers, equipments } = useSelector(trainingCentreRegReducer);

  const contextObject = useContext(TrainingCentreRegContext);

  useEffect(() => {
    const element = document.getElementById("treg-container");
    element.scrollIntoView({ behavior: "smooth" });

    // sync local store
    dispatch({
      type: "syncLocalStore",
      body: {
        trainers,
      },
    });
  }, []);

  // watch for file upload and extract base 64
  // useEffect(() => {
  //   const fileReader = new FileReader();

  //   if (state.fileHolder) {
  //     fileReader.onload = (e) => {
  //       const base64 = e.target.result;

  //       if (base64) {
  //         dispatch({
  //           type: "uploadedPassportPhoto",
  //           body: {
  //             file: base64,
  //           },
  //         });
  //       }
  //     };
  //     fileReader.readAsDataURL(state.fileHolder);
  //   }

  //   return () => {
  //     if (fileReader && fileReader.readyState === 1) {
  //       fileReader.abort();
  //     }
  //   };
  // }, [state.fileHolder]);

  // refactor this
  let newOptions = [];
  contextObject.parsedListOfSkills.map((skill) => {
    newOptions.push({
      value: skill.id,
      label: skill.label,
    });
  });

  function handleUserActions(type, body) {
    dispatch({
      type: type,
      body: body,
    });
  }

  // function fileUploadHandler(event) {
  //   const { files } = event.target;
  //   const imageFullName = files[0].name.split(".");
  //   const { firstName, middleName, lastName } = values;

  //   const imageName = `${firstName} ${middleName} ${lastName}`;
  //   const imageExtension = imageFullName[1];

  //   dispatch({
  //     type: "uploadedPassportPhoto",
  //     body: {
  //       fileHolder: files[0],
  //       fileName: imageName,
  //       fileExtension: `.${imageExtension}`,
  //     },
  //   });
  // }

  function handleFormSubmit(values, actions) {
    const submitObject = {
      ...values,
      isOwner: state.isOwner,
      certifications: state.listOfCerts,
    };

    dispatch({
      type: "stageStaffInfo",
      body: submitObject,
    });
    dispatch({
      type: "emptyCertList",
    });
    actions.resetForm();
  }

  function navigateToNextPage() {
    setSendDataToGlobalStore(true);

    globalDispatch(
      saveFormDataPartTwo({
        trainers: state.trainers,
      })
    );

    globalDispatch(nextFormStep());
  }

  function navigateToPreviousPage() {
    setSendDataToGlobalStore(true);

    globalDispatch(
      saveFormDataPartTwo({
        trainers: state.trainers,
      })
    );

    globalDispatch(previousFormStep());
  }

  // Markups
  const sectionFourMarkup = [
    [
      {
        type: "textField",
        name: "firstName",
        label: "First Name*",
      },
      {
        type: "textField",
        name: "middleName",
        label: "Other Name(s)",
      },
    ],
    [
      {
        type: "textField",
        name: "lastName",
        label: "Last Name*",
      },
      {
        type: "singleSelect",
        name: "skillId",
        label: "Skill Area*",
        options: newOptions,
      },
    ],
    [
      {
        type: "textField",
        label: "Years of Experience*",
        name: "yearsOfExperience",
      },
      {
        type: "textField",
        label: "General Remarks*",
        name: "generalComment",
      },
    ],
  ];

  // const ownerOnlyMarkup = [
  //   {
  //     type: "textField",
  //     label: "Owner's Phone Number",
  //     name: "ownerPhoneNumber",
  //   },
  // ];

  // staff composisition datatable configuration
  const staffCompositionTableColumns = [
    {
      name: "firstName",
      label: "First Name",
    },
    {
      name: "lastName",
      label: "Last Name",
    },
    {
      name: "middleName",
      label: "Middle Name",
    },
    {
      name: "skillId",
      label: "Skill Area",
      options: {
        customBodyRender: (value) => {
          const skillName = contextObject.parsedListOfSkills.find(
            (skill) => skill.id === value
          )?.label;
          return skillName;
        },
      },
    },
    {
      name: "isOwner",
      label: "Position",
      options: {
        customBodyRender: (value) => {
          return value ? "Owner" : "Staff";
        },
      },
    },
    {
      name: "certifications",
      label: "Certifications Acquired",
      options: {
        customBodyRender: (value) => {
          const certs = value.reduce((acc, cur) => {
            return `${cur.certificationName}, ${acc} `;
          }, "");

          return certs.trim().slice(0, -1);
        },
      },
    },
    {
      name: "yearsOfExperience",
      label: "Years of Experience",
    },
    {
      name: "generalComment",
      label: "General Remarks",
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Button
              variant="outlined"
              size="small"
              sx={{
                color: "red",
                border: "0.5px solid red",
              }}
              onClick={() =>
                handleUserActions("deletedStaffData", tableMeta.rowIndex)
              }
            >
              Delete
            </Button>
          );
        },
      },
    },
  ];

  const staffCompositionTableOptions = {
    ...tableCustomization,
  };

  // acquired certifications datatable configuration
  const certificationsTableColumns = [
    {
      name: "certificationName",
      label: "Name of Certificate",
    },
    {
      name: "issuedBy",
      label: "Name of Issuer",
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Button
              variant="outlined"
              size="small"
              sx={{
                color: "red",
                border: "0.5px solid red",
              }}
              onClick={() =>
                handleUserActions(
                  "deletedStagedCertificate",
                  tableMeta.rowIndex
                )
              }
            >
              Delete
            </Button>
          );
        },
      },
    },
  ];

  const certificationsTableOptions = {
    ...tableCustomization,
  };

  return (
    <>
      <Formik
        initialValues={{
          ...INITIAL_STATE,
        }}
        validationSchema={formValidationSchema}
        onSubmit={handleFormSubmit}
      >
        <Form>
          <h2 id="section-four-heading" style={{ marginTop: "24px" }}>
            Section 4
          </h2>
          <p>Staff Composition</p>
          <p>
            Fill in the following information about the staff trainers at your
            center - including yourself
          </p>

          <Grid
            container
            gap="2rem"
            sx={{
              padding: "1rem 0",
            }}
          >
            <Grid
              container
              direction={"column"}
              sx={{
                border: "1px solid lightgrey",
                padding: "2rem",
                borderRadius: "5px",
              }}
              gap="1rem"
            >
              <Grid item xs>
                <h4> Staff Composition Form</h4>
              </Grid>
              <Grid container item xs direction={"column"}>
                {sectionFourMarkup.map((row, index) => (
                  <Grid
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                    container
                    item
                    xs
                    spacing={3}
                  >
                    {row.map((field, index) => (
                      <Grid item xs key={index}>
                        {field.type === "textField" && (
                          <TextFieldTR label={field.label} name={field.name} />
                        )}

                        {field.type === "singleSelect" && (
                          <SelectTR
                            label={field.label}
                            name={field.name}
                            options={field.options}
                          />
                        )}
                      </Grid>
                    ))}
                  </Grid>
                ))}
                <Grid
                  item
                  xs
                  container
                  direction={"column"}
                  gap={"2rem"}
                  sx={{
                    paddingTop: "2rem",
                  }}
                >
                  {/* <ExtractEnteredNames setValues={setValues} /> */}
                  {/* <Grid item xs container direction={"row"} gap={"2rem"}>
                    <p>Are you an owner? </p>
                    <Grid item xs container direction={"row"}>
                      <p>No</p>
                      <Switch
                        checked={state.isOwner}
                        onChange={() =>
                          handleUserActions("toggledStaffStatus", {})
                        }
                      />
                      <p>Yes</p>
                    </Grid>
                  </Grid> */}

                  {/* {state.isOwner && (
                    <Grid item xs container direction={"column"} gap={"2rem"}>
                      {ownerOnlyMarkup.map((field, index) => (
                        <Grid item xs key={index}>
                          {field.type === "textField" && (
                            <TextFieldTR
                              label={field.label}
                              name={field.name}
                            />
                          )}
                        </Grid>
                      ))}
                      <Grid
                        item
                        xs
                        sx={{
                          border: "2px solid lightgrey",
                          borderRadius: "7px",
                          padding: "4rem",
                          display: "flex",
                          justifyContent: "center",
                          borderStyle: "dashed",
                        }}
                      >
                        <input
                          type="file"
                          id="file"
                          onChange={fileUploadHandler}
                          accept="image/*"
                        />
                      </Grid>
                    </Grid>
                  )} */}

                  <AcquiredCertificationsForm dispatch={dispatch} />

                  <MUIDataTable
                    columns={certificationsTableColumns}
                    options={certificationsTableOptions}
                    data={state.listOfCerts}
                    title={
                      <Typography
                        style={{
                          // fontWeight: "bold",
                          fontSize: "18.7px",
                        }}
                        variant={"body"}
                      >
                        List of Acquired Certifications
                      </Typography>
                    }
                  />

                  <div>
                    <ButtonTR
                      variant="contained"
                      color="primary"
                      sx={{ width: "fit-content" }}
                    >
                      Add Staff Info
                    </ButtonTR>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs>
              <MUIDataTable
                columns={staffCompositionTableColumns}
                options={staffCompositionTableOptions}
                data={state.trainers}
                title={
                  <Typography
                    style={{
                      // fontWeight: "bold",
                      fontSize: "18.7px",
                    }}
                    variant={"body"}
                  >
                    List of Added Staff
                  </Typography>
                }
              />
            </Grid>
          </Grid>
        </Form>
      </Formik>
      <SectionFive
        dataSubmitTrigger={sendDataToGlobalStore}
        setEquipmentAdded={setEquipmentAdded}
      />

      <Grid
        item
        xs
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "3rem",
        }}
      >
        <Button onClick={navigateToPreviousPage}>Back</Button>
        <Button
          onClick={navigateToNextPage}
          variant={"contained"}
          disabled={
            !(equipmentAdded || equipments.length > 0) ||
            state.trainers.length < 1
          }
        >
          Next
        </Button>
      </Grid>
    </>
  );
};

export default PartTwo;
